import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchClientJobDescriptionTableAndFilterSchema } from "model/ClientJobDescriptionModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const JobDescriptionContext = createContext();

export const JobDescriptionProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [jobDescriptionContextData, setJobDescriptionContextData] = useState();

  const fetchJobDescriptionContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:jobDescription", () =>
        fetchClientJobDescriptionTableAndFilterSchema({})
      );
      if (response?.success) {
        setJobDescriptionContextData(response?.data);
      } else {
        setError(response?.message || "Unable to fetch job description metadata");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <JobDescriptionContext.Provider
      value={{
        fetchJobDescriptionContextData,
        jobDescriptionContextData,
        loading,
        error,
      }}
    >
      {children}
    </JobDescriptionContext.Provider>
  );
};

export const useJobDescriptionContext = () => useContext(JobDescriptionContext);
